import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ImageWithSkeleton from '../../../../../../../components/ImageWithSkeleton.js'

export default function CourseBrief ({ race, distance }) {
  const { brief } = race?.raceDistances?.find(r => r.distance === distance) || {}
  return (
    <Box>
      {race?.showBriefSplashes && <ImageWithSkeleton {...{ src: `https://d1hi0tbu2kom2c.cloudfront.net/img/race-splash/${distance}.png` }} square oneSize />}
      <Typography
        sx={{
          mt: 2,
          whiteSpace: 'pre-line'
        }}
      >
        {brief}
      </Typography>
    </Box>
  )
}
